//
//
//
//
//
//

	export default{
        props: {
            eventHub: Object
        },
		mounted(){
		//   if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '赛事动态数据'])}
	      this.$nextTick(() => {
	        this.indexContentHeight = document.body.clientHeight-230;
	      })
		},
		data(){
			return{
				content:'暂无动态数据',
				indexContentHeight:0,
			}
		},
		methods:{
			initTab(){

			}
		}
	}



// WEBPACK FOOTER //
// ./src/views/matchDynamicData.vue